"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
function compileFontStyleString(mainFont) {
    const defaultFont = (mainFont === null || mainFont === void 0 ? void 0 : mainFont.defaultSelected)
        ? `'${mainFont.defaultSelected}'`
        : `'YS Text Web'`;
    const brandingFont = `${defaultFont}, Arial, Helvetica, sans-serif`;
    return `
        {
            ${brandingFont ? `--main-font: ${brandingFont};` : ''}
            ${(mainFont === null || mainFont === void 0 ? void 0 : mainFont.color) ? `--text-color: ${mainFont.color};` : ''}
        }
    `;
}
function brandingFontStyles(branding = {}) {
    const { mainFont, darkTheme } = branding;
    const lightThemeString = compileFontStyleString(mainFont);
    if (darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.mainFont) {
        const darkThemeString = compileFontStyleString(Object.assign(Object.assign({}, mainFont), darkTheme.mainFont));
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='light'] ${lightThemeString}
            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}

        .pythia-surveys-root[data-theme='light'] ${lightThemeString}
    `;
}
exports.default = brandingFontStyles;
